module.exports = "<p>\n  wait works!\n</p>\n"